import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { tap, timeout } from 'rxjs/operators';
import { EncryptionProviderService } from '@shared/encryption.service';
import { AuthService } from '@shared/auth.service';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private readonly http: HttpClient,
    private encryptionProviderService: EncryptionProviderService
  ) {}
  

  getData = (endPoint): Observable<any> => {
    const headers = this.getHeaders();
    return Observable.create((observer) => {
      this.http
        .get<any>(endPoint, {headers})
        .pipe(timeout(60000))
        .subscribe(
          (response) => {
            if (response['eData']) {
              response = JSON.parse(
                this.encryptionProviderService.decryptData(response['eData'])
              );
            }
            if (response.status === 0) {
              observer.next(response);
            } else {
              observer.error(response);
            }
          },
          (error) => {
            observer.error(error);
          },
          () => observer.complete()
        );
    });
  };

  public postData(endPoint, data): Observable<any> {
    const headers = this.getHeaders();
    return Observable.create((observer) => {
      this.http
        .post<any>(endPoint, data, { headers})
        .pipe(timeout(60000))
        .subscribe(
          (response) => {
            if (response['eData']) {
              response = JSON.parse(this.encryptionProviderService.decryptData(
                response['eData']
              ));
            }
            if (response.status === 0) {
              observer.next(response);
            } else {
              observer.error(response);
            }
          },
          (error) => {
            observer.error(error);
          },
          () => observer.complete()
        );
    });
  }

  public getHeaders():{[header: string]: string | string[] } {
    const headers:  {[header: string]: string | string[] } ={}     // set session token if logged in user
       if (AuthService.isLoggedIn()) {
        headers['session-token'] = AuthService.getToken();
      }
      return headers;
  }
}
